module.exports = __webpack_public_path__ + "img/about__back.ab642ecc.png";